var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9213 5.26763L11.5216 1.12188C11.3591 1.0417 11.1803 1 10.999 1C10.8178 1 10.639 1.0417 10.4765 1.12188L2.07682 5.26763C1.7548 5.42541 1.48332 5.67009 1.29304 5.97403C1.10276 6.27797 1.00126 6.62907 1 6.98766V15.8623C1 16.9242 1.87203 17.7852 2.94789 17.7852H19.0521C20.128 17.7852 21 16.9242 21 15.8623V6.98766C20.9986 6.62887 20.8968 6.27763 20.7061 5.97367C20.5155 5.6697 20.2436 5.42514 19.9213 5.26763V5.26763Z",
    stroke: "#11216C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7929 14.7085L11.5791 9.87546C11.3766 9.71794 11.1273 9.63242 10.8708 9.63242C10.6142 9.63242 10.3649 9.71794 10.1624 9.87546L3.9481 14.7085M13.5626 11.1993L20.1004 6.24805M1.64062 6.24805L8.32268 11.2955",
    stroke: "#11216C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.a39d81609a27833500a4aa7f69ee2d19.svg";
export { ForwardRef as ReactComponent };